module.exports = __webpack_public_path__ + "static/media/upper_part.90a1c0ce.jpg";